import { Badge } from '@startupquickstart/frontend';
import { PURPOSE_CONFIG } from '@/components/prompts/prompt-purpose-utils';

interface Props {
  purpose: string;
}

/**
 * Color-coded badge for displaying a PromptPurpose value.
 *
 * @param purpose - The purpose enum value to render.
 * @returns A styled Badge component.
 */
export function PromptPurposeBadge({ purpose }: Props) {
  const config = PURPOSE_CONFIG[purpose];

  if (!config) {
    return <Badge variant="outline">{purpose}</Badge>;
  }

  return (
    <Badge variant="outline" className={config.className}>
      {config.label}
    </Badge>
  );
}
